let activeTaskId = null

export const setActiveSpecRateTaskId = id => {
  activeTaskId = id
}

export const getActiveSpecRateTaskId = () => activeTaskId
